import React, { createContext, useContext, useState } from "react";

// Cria o contexto
const PedidosContext = createContext();

// Mock de pedidos (por enquanto fixo, mas substituível por API futuramente)
const mockPedidos = [
  {
    id: 97,
    data: "16/11/2024 às 22:18",
    itens: ["1x Grande", "1x Grande"],
    valor: 100.0,
    status: "Finalizado",
  },
  {
    id: 108,
    data: "01/11/2024 às 21:55",
    itens: ["1x Grande", "1x Refrigerantes - 2lts"],
    valor: 64.0,
    status: "Finalizado",
  },
  {
    id: 103,
    data: "21/09/2024 às 21:59",
    itens: ["1x Grande"],
    valor: 53.0,
    status: "Finalizado",
  },
];

// Provedor do contexto
export const PedidosProvider = ({ children }) => {
  const [pedidos, setPedidos] = useState(mockPedidos);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);

  const fetchPedidos = async () => {
    // Lógica futura para buscar pedidos de uma API
    console.log("Buscando pedidos...");
  };

  const abrirModal = (pedido) => {
    setPedidoSelecionado(pedido);
  };

  // Função para fechar o modal
  const fecharModal = () => {
    setPedidoSelecionado(null);
  };

  return (
    <PedidosContext.Provider value={{ pedidos, setPedidos, fetchPedidos, abrirModal, fecharModal, pedidoSelecionado }}>
      {children}
    </PedidosContext.Provider>
  );
};

// Hook para usar o contexto
export const usePedidos = () => {
  return useContext(PedidosContext);
};
